<template>
  <at-panel v-if="isLoading">
    <template #header>
      <div class="w-1/2">
        <at-skeleton type="row" />
      </div>
    </template>
    <div class="-m-2">
      <div class="p-2">
        <at-skeleton type="row" />
      </div>
      <div class="p-2">
        <at-skeleton type="row" />
      </div>
    </div>
  </at-panel>

  <at-panel v-else :title="$t('entities.rejectCase.cancelReason.title')">
    <at-skeleton v-if="isLoading" />

    <h4 v-else class="text-gray-900 dark:text-white">
      {{ rejectCase.cancel_reason }}
    </h4>
  </at-panel>
</template>

<script setup>
  import { AtPanel, AtSkeleton } from '@packages/aliftech-ui';

  defineProps({
    rejectCase: {
      type: Object,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  });
</script>
